'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.lp__pagination {\n  margin-top: calc(calc(0.75 * 1rem) + calc(0.25 * 1rem));\n  display: flex;\n  justify-content: center;\n}\n.lp__pagination ul {\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  list-style-type: none;\n  margin-bottom: 0;\n}\n.lp__pagination ul li {\n  cursor: pointer;\n  color: #989898;\n}\n.lp__pagination ul li a {\n  text-decoration: none;\n  color: #1D66DD;\n}\n.lp__pagination ul li:hover a {\n  text-decoration: underline;\n}\n.lp__pagination ul li:not(:first-child):not(:last-child) {\n  margin: 0 calc(0.75 * 1rem);\n}\n.lp__pagination ul li.bordered {\n  padding: 5px 10px;\n  border-radius: calc(0.25 * 1rem);\n  border: 1px solid #d3d3d3;\n}\n.lp__pagination ul li.bordered:hover {\n  transition: 0.5s;\n  border: 1px solid #1D66DD;\n  color: #1D66DD;\n}\n.lp__pagination ul li.selected {\n  padding: 5px 10px;\n  border: 1px solid #1D66DD;\n  color: #1D66DD;\n}\n.lp__pagination ul li i {\n  font-size: large;\n}");
//# sourceMappingURL=Pagination.scss.js.map
